import { AbstractControl, ValidatorFn } from '@angular/forms';

export function wrapValidator(
  validator: ValidatorFn,
  errorMessage: string
): ValidatorFn {
  return (control: AbstractControl): any | null =>
    validator(control) ? { error: errorMessage } : null;
}
